export var Language;
(function (Language) {
    Language["En"] = "en";
    Language["Es"] = "es";
    Language["Fr"] = "fr";
    Language["PtBr"] = "pt-BR";
})(Language || (Language = {}));
